const REGISTRY_KEY = '__managerNavRegistry';

function registry() {
    if (!window[REGISTRY_KEY]) {
        window[REGISTRY_KEY] = {};
    }
    return window[REGISTRY_KEY];
}

export function registerManagerNavAction(name, fn) {
    const key = String(name || '').trim();
    if (!key) {
        throw new Error('registerManagerNavAction: name is required');
    }
    if (typeof fn !== 'function') {
        throw new Error('registerManagerNavAction: fn is required');
    }
    registry()[key] = fn;
}

export function getManagerNavAction(name) {
    const key = String(name || '').trim();
    if (!key) {
        throw new Error('getManagerNavAction: name is required');
    }
    const fn = registry()[key];
    if (typeof fn !== 'function') {
        throw new Error('getManagerNavAction: ' + key + ' is not registered');
    }
    return fn;
}

export function runManagerNavAction(name, ...args) {
    return getManagerNavAction(name)(...args);
}
